import React from 'react';
import { MinusIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { NOT_NEEDED, ONLY_NEEDED } from '../../data/content';
export function Beginners() {
  return;
}